import React from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";

const EnterprisePlanContactHeader = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="dashboard-page-title">
      <Button
        onClick={handleBack}
        type="text"
        size="middle"
        icon={<ArrowLeftOutlined style={{ fontSize: "20px" }} />}
      />

      <Typography.Title level={4} style={{ margin: 0 }}>
        Contact Sales
      </Typography.Title>
    </div>
  );
};

export default EnterprisePlanContactHeader;
